






































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Community, CheckEvent } from '@/interfaces';
import BmnCheckbox from './BmnCheckbox.vue';

@Component({
  components: {
    'bmn-checkbox': BmnCheckbox,
  },
})
export default class BmnSidebar extends Vue {
  public comms: Community[];

  public showSidebar = false;

  public hide: boolean;

  @Prop()
  public hidden: boolean;
  @Prop()
  private communities: Community[];

  constructor() {
    super();
    this.comms = this.communities;
  }

  @Watch('hidden')
  public onHiddenChange(value) {
    this.hide = value;
  }

  public data() {
    return {
      hide: this.hidden
    };
  }

  public onChecked(event: CheckEvent): void {
    this.$emit('checked', event);
  }

  public infoClicked(): void {
    this.$emit('infoClicked');
  }

  public mounted(): void {
    this.showSidebar = true;
  }

  public handleClicked() {
    this.hide = false;
    this.$emit('sidebarOpen');
  }
}
